import React, { useState , useContext } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import Table from 'react-bootstrap/Table';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Swal from 'sweetalert2';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { postRequest } from '../../../lib/api';
import { AuthContext } from '../../../authContext/context';
import dayjs from 'dayjs';

const Reschedule = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { id } = useParams();
  const authCtx = useContext(AuthContext);

  const { fullname, ti_case_ref } = location.state || {};

  const [selectedDateTime, setSelectedDateTime] = useState(dayjs());


  const handleSubmit = async () => {
    if (!selectedDateTime) {
      Swal.fire('Error', 'Please select a date and time', 'error');
      return;
    }

    try {
      const response = await postRequest(`private/rescheduleAppointment/${id}`, {
        appointment_datetime: selectedDateTime,
      },authCtx.token);

      if (response?.status) {
        Swal.fire('Success', 'Appointment rescheduled successfully', 'success').then(() => {
          navigate(-1);
        });
      } else {
        Swal.fire('Error', response?.message || 'Something went wrong', 'error');
      }
    } catch (error) {
      Swal.fire('Error', 'Server error', 'error');
      console.error(error);
    }
  };

  return (
    <>
      <div className='page-header'>
        <h1 className='mt-0'>Reschedule Appointment</h1>
      </div>

      <div className='page-top-formview mb-3'>
        <Table striped responsive bordered>
          <tbody>
            <tr>
              <td>
                <strong>Solicitor:</strong> {fullname} &nbsp;&nbsp;
                <strong>TI Case Ref:</strong> {ti_case_ref}
              </td>
            </tr>
          </tbody>
        </Table>

        <div className='mb-3'>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer components={['DateTimePicker']}>
              <DateTimePicker
                label="New Date/Time"
                value={selectedDateTime}
                onChange={(newValue) => setSelectedDateTime(newValue)}
              />
            </DemoContainer>
          </LocalizationProvider>
        </div>

        <Stack spacing={2} direction="row">
          <Button variant="outlined" onClick={() => navigate(-1)} className='red-outline-btn text-capitalize'>
            Cancel
          </Button>
          <Button variant="contained" onClick={handleSubmit} className='red-bg red-button text-capitalize'>
            Submit
          </Button>
        </Stack>
      </div>
    </>
  );
};

export default Reschedule;
